<template>
  <div>
    <h3>REPORTS <small class="float-right paid-separately">paid separately</small></h3>
    <b-nav tabs vertical>
      <b-nav-item to="/instagram-coach-reports" @click="changeCurrentRoute">
        <font-awesome-icon :icon="['fab', 'instagram']" fixed-width />
        Instagram Account Coach
      </b-nav-item>
      <!-- <b-nav-item to="/hashtag-reports" @click="changeCurrentRoute">
        <font-awesome-icon :icon="['fab', 'twitter']" fixed-width />
        Twitter Hashtag Reports
      </b-nav-item> -->
    </b-nav>
    <br>
    <h3>RITETAG PRO TOOLS</h3>
    <b-alert variant="warning" v-if="info.trialAlert && !info.trialAlertExpired" show>
     {{info.days}} days left in the trial
      <b-btn variant="warning" class="upgrade-button float-right" size="sm" href="https://ritekit.com/pricing">
      <font-awesome-icon :icon="['fas', 'star']" /> Upgrade</b-btn>
    </b-alert>
    <b-alert variant="warning" v-if="info.noPlanStarted" show>
      Start 7-day free trial
      <b-btn variant="warning" class="upgrade-button float-right" size="sm" @click="startTrial">
        Start now
      </b-btn>
    </b-alert>
    <b-alert variant="warning" v-if="info.trialAlertExpired" show>
      Trial expired
      <b-btn variant="warning" class="upgrade-button float-right" size="sm" href="https://ritekit.com/pricing">
      <font-awesome-icon :icon="['fas', 'star']" /> Upgrade</b-btn>
    </b-alert>
    <b-nav tabs vertical>
      <b-nav-item to="/hashtag-suggestions" @click="changeCurrentRoute" :disabled='disableButtons'>
        <font-awesome-icon :icon="['ritetag', 'ritetagHashtagSuggestion']" fixed-width />
        Hashtag Suggestions
      </b-nav-item>
<!--      <b-nav-item to="/instagram-hashtag-generator"  @click="changeCurrentRoute" :disabled='disableButtons'>-->
<!--        <font-awesome-icon :icon="['fas', 'mobile-alt']" fixed-width />-->
<!--        Hashtag Generator for Instagram <b-badge variant="success">NEW</b-badge>-->
<!--      </b-nav-item>-->
      <b-nav-item to="/instagram-banned-hashtags-tool" @click="changeCurrentRoute" :disabled='disableButtons'>
        <font-awesome-icon :icon="['fas', 'ban']" fixed-width />
        Instagram Banned Hashtags
      </b-nav-item>
      <b-nav-item to="/tagsets" @click="changeCurrentRoute" :disabled='disableButtons'>
        <font-awesome-icon :icon="['ritetag', 'ritetagHashtagSet']" fixed-width />
        Hashtag Sets
      </b-nav-item>
      <b-nav-item to="/hashtag-comparison" @click="changeCurrentRoute" :disabled='disableButtons'>
        <font-awesome-icon :icon="['fas', 'balance-scale-left']" fixed-width />
        Hashtag Comparison
      </b-nav-item>
      <b-nav-item v-if="chromeExtension" href="https://chrome.google.com/webstore/detail/ritetag/hclhpnhohpmlbadmeieecaandnglfodm" target="_blank" :disabled='disableButtons'>
        <font-awesome-icon :icon="['fab', 'chrome']" fixed-width /> Chrome Extension
      </b-nav-item>
<!--      <b-nav-item v-if="safariExtension" href="https://safari-extensions.apple.com/details/?id=com.ritekit.ritetag-8U5U34M3NP" target="_blank" :disabled='disableButtons'>-->
<!--        <font-awesome-icon :icon="['fab', 'safari']" fixed-width /> Safari Extension-->
<!--      </b-nav-item>-->
      <b-nav-item v-if="firefoxExtension" href="https://addons.mozilla.org/en-US/firefox/addon/ritetag-ritekit/" target="_blank" :disabled='disableButtons'>
        <font-awesome-icon :icon="['fab', 'firefox']" fixed-width /> Firefox Extension
      </b-nav-item>
      <b-nav-item href="https://play.google.com/store/apps/details?id=com.ritekit.ritetag" target="_blank" :disabled='disableButtons'>
         <font-awesome-icon :icon="['fab', 'android']" fixed-width />
        RiteTag Toolkit (Android)
      </b-nav-item>
      <b-nav-item href="https://itunes.apple.com/cz/app/ritetag/id1151267309?mt=8" target="_blank" :disabled='disableButtons'>
         <font-awesome-icon :icon="['fab', 'apple']" fixed-width />
        RiteTag Toolkit (iOS)
      </b-nav-item>
    </b-nav>
    <br>
    <b-alert show variant="warning" class="hashtag-legend">
      <div class="text-left">
        <p class="legend-title">Legend for #hashtags</p>
        <TagStyle :color="3" class="mb-1"></TagStyle>&nbsp;
        <TagStyle :color="2" class="mb-1"></TagStyle>&nbsp;
        <TagStyle :color="4" class="mb-1"></TagStyle>&nbsp;
        <TagStyle :color="1" class="mb-1"></TagStyle>&nbsp;
        <TagStyle :color="0" class="mb-1"></TagStyle>&nbsp;
        <TagStyle :color="5" class="mb-2"></TagStyle>
        <br>
        <a href="https://help.ritekit.com/en/article/all-about-ritetags-color-grading-system-and-how-to-make-smart-choices-with-the-hashtags-generated-by-the-app-and-extension-13po878/" target="_blank">
          How RiteTag assesses hashtags</a>
      </div>
    </b-alert>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import TagStyle from './helpers/TagStyle'

  export default {
    name: "SideNav",
    props: ['currentRoute'],
    components: {
            TagStyle
    },
    data() {
      return {
        chromeExtension: false,
        firefoxExtension: false,
        safariExtension: false,

      }
    },
    methods: {
      ...mapActions('account', ['startTrial']),
      changeCurrentRoute () {
        if (this.currentRoute !== this.$route.path) {
          this.$emit('changeRoute')
        } else if (!this.info.loggedIn) {
          this.$root.$emit('login-fade-in')
        }
      }
    },
    computed: {
        ...mapState('account', ['info']),
      disableButtons() {
          return this.info.trialAlertExpired || this.info.noPlanStarted
      }
    },
    created() {
      if (navigator.userAgent.indexOf("Chrome") != -1) {
        this.browserType = 'Chrome';
        this.chromeExtension = true;
      }
      else if (navigator.userAgent.indexOf("Safari") != -1) {
        this.browserType = 'Safari';
        this.safariExtension = true
      }
      else if (navigator.userAgent.indexOf("Firefox") != -1) {
        this.browserType = 'Firefox';
        this.firefoxExtension = true
      }

    }
  }
</script>

<style scoped lang="scss">
  a {
    color: #2F78C1;
  }
  h3 {
    font-size: 14px;
    color: $gray-500;
    margin-top: 10px;
    letter-spacing: 1px;
  }
  .paid-separately {
    color: $gray-500;
    font-family: $font-family-sans-serif;
    text-transform: uppercase;
    margin-top: 3px;
  }

  .alert-warning {
    padding-right: 3px;
    padding-left: 15px;
  }

  .nav {
    border-bottom: 0px;
  }
   .nav-tabs .nav-link {
    margin: 4px 0px;
    line-height: 16px;
    border: 0px;
    padding-left: 30px;
    text-indent: -21px;
    color: $gray-700;
    border-left: 3px solid transparent;
    border-radius: 0;

    &.disabled {
      color: $gray-400;
    }

    .badge {
      text-indent: 0px;
    }
    svg {
      color: $gray-400;
    }

  }
  .nav-tabs .nav-link.router-link-active {
    color:$gray-800;
    // background-color: #fff;
    // background-repeat: no-repeat;
    // background-position: 0px 100%;
    // background-size: 100% 2px;
    // background-image: linear-gradient(to right, #c12f93, white);
    border: 0px;
    font-weight: bold;
    border-left: 3px solid $primary;

    svg {
      color: $primary;
    }
  }

  .nav-tabs .nav-link:hover {
    color: $gray-900;
    border-left-color: transparent;
    svg  {
      color: $gray-600;
    }
  }

  .nav-tabs .nav-link.router-link-active:hover {
    color: $gray-900;
    border-left-color: $primary;
    svg  {
      color: $primary;
    }
  }

  @keyframes Gradient {
    0% {
      background-position: -400px 100%;
    }
    100% {
      background-position: 0% 100%;
    }
}

  .tagStyles {
    margin: 1px;
  }

.upgrade-button {
    color: #545454;
    margin-left: 10px;
    margin-right: 2px;
    margin-top: -6px;
    line-height: 25px;
}

.upgrade-button:hover {
    color: #545454;
}

</style>
